import Script from 'next/script';

export const WebAnalytics = ({ load }) => {
  return load ? (
    <Script src="/assets/privacy-policy/ati-ee24.js" strategy="lazyOnload" />
  ) : null;
};

export default WebAnalytics;
